import {createAction} from '@reduxjs/toolkit';

export const postMarketingChannel = createAction<{marketingChannel: string}>(
  'postMarketingChannel',
);
export const postMarketingChannelSuccess = createAction(
  'postMarketingChannelSuccess',
);
